module.exports = __webpack_public_path__ + "static/media/phone.c7e65bb7.svg";